module.exports = __webpack_public_path__ + "img/youtube.d61e1613.svg";